import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { BaseIconComponent } from '../../private/base-icon/base-icon.component';

/** Additional inputs:
 * `multiple:boolean = false` for multiple users icon version.
 * `filled:boolean = false` for filled user icon version.
 *
 * At the moment there is no implementation of filled non multiple user icon version (it will render filled multiple).
 * */
@Component({
  selector: 'icon-user',
  imports: [CommonModule],
  templateUrl: './user-icon.component.html',
  styleUrl: '../styles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserIconComponent extends BaseIconComponent {
  readonly multiple = input(false);
  readonly filled = input(false);
}
